module.exports = __webpack_public_path__ + "static/media/film.e8d9779e.svg";